"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _LoadingSpinner = _interopRequireDefault(require("../loadingspinner/LoadingSpinner"));

require("./Input.css");

function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Input = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(Input, _Component);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Input);
    _this = _super.call(this, props);
    _this.state = {
      hasFocus: false
    };
    _this.fieldWrapperHandleClick = _this.fieldWrapperHandleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.fieldWrapperHandleDoubleClick = _this.fieldWrapperHandleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onFocus = _this.onFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.onBlur = _this.onBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Input, [{
    key: "onFocus",
    value: function onFocus(evt) {
      this.setState({
        hasFocus: true
      });

      if (this.props.onFocus) {
        this.props.onFocus(evt);
      }

      if (this.props.selectOnFocus === true) {
        this.inputRef.select();
      }
    }
  }, {
    key: "onBlur",
    value: function onBlur(evt) {
      this.setState({
        hasFocus: false
      });

      if (this.props.onBlur) {
        this.props.onBlur(evt);
      }
    }
  }, {
    key: "fieldWrapperHandleClick",
    value: function fieldWrapperHandleClick() {
      this.inputRef.focus();
    }
  }, {
    key: "fieldWrapperHandleDoubleClick",
    value: function fieldWrapperHandleDoubleClick() {
      this.inputRef.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          disabled = _this$props.disabled,
          loading = _this$props.loading,
          messageType = _this$props.messageType,
          prefix = _this$props.prefix,
          readOnly = _this$props.readOnly,
          selectOnFocus = _this$props.selectOnFocus,
          size = _this$props.size,
          suffix = _this$props.suffix,
          type = _this$props.type,
          otherProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className", "disabled", "loading", "messageType", "prefix", "readOnly", "selectOnFocus", "size", "suffix", "type"]);
      var classNames = (0, _classnames["default"])(['stx-input', {
        'stx-input--is-disabled': disabled
      }, {
        'stx-input--is-loading': loading
      }, {
        'stx-input--is-read-only': readOnly
      }, {
        'stx-input--has-focus': this.state.hasFocus
      }, {
        'stx-input--alert': messageType === 'alert' || messageType === 'error'
      }, {
        'stx-input--warning': messageType === 'warning'
      }, {
        'stx-input--success': messageType === 'success'
      }, {
        'stx-input--small': size === 'small'
      }, this.props.className]);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classNames,
        onClick: this.fieldWrapperHandleClick,
        onDoubleClick: this.fieldWrapperHandleDoubleClick
      }, prefix && /*#__PURE__*/_react["default"].createElement("div", {
        className: "stx-input__prefix"
      }, prefix), /*#__PURE__*/_react["default"].createElement("input", (0, _extends2["default"])({}, otherProps, {
        ref: function ref(input) {
          _this2.inputRef = input;
        },
        type: type,
        className: "stx-input__input-element",
        disabled: disabled,
        readOnly: readOnly,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        "aria-disabled": disabled,
        "aria-readonly": readOnly
      })), suffix && /*#__PURE__*/_react["default"].createElement("div", {
        className: "stx-input__suffix"
      }, suffix), loading && /*#__PURE__*/_react["default"].createElement(_LoadingSpinner["default"], {
        className: "stx-input__spinner"
      }));
    }
  }]);
  return Input;
}(_react.Component);

Input.defaultProps = {
  selectOnFocus: false,
  type: 'text'
};
Input.propTypes = {
  /** Optional className for the Input component */
  className: _propTypes["default"].string,

  /** A node for placing read only content before the input element */
  prefix: _propTypes["default"].node,

  /** A node for placing read only content after the input element */
  suffix: _propTypes["default"].node,

  /** The input field type */
  type: _propTypes["default"].oneOf(['text', 'date', 'datetime-local', 'time', 'search', 'number', 'tel', 'email', 'url', 'password', 'file']),

  /** Size modifier */
  size: _propTypes["default"].oneOf(['small', '']),

  /** The type of message to display */
  messageType: _propTypes["default"].oneOf(['alert', 'warning', 'success', '']),

  /** Whether or not the field is disabled */
  disabled: _propTypes["default"].bool,

  /** Whether or not the field is read only */
  readOnly: _propTypes["default"].bool,

  /** Whether or not the input field is in a loading state */
  loading: _propTypes["default"].bool,

  /** Whether or not the value of the field should be selected when the field receives focus */
  selectOnFocus: _propTypes["default"].bool,

  /** Event fires when the input receives focus */
  onFocus: _propTypes["default"].func,

  /** Event fires when the input loses focus */
  onBlur: _propTypes["default"].func
};
var _default = Input;
exports["default"] = _default;